import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";

const isoToFR = (iso) => {
  if (!iso) return "";
  const [y, m, d] = iso.split("-");
  return y && m && d ? `${d}/${m}/${y}` : "";
};

const toISODate = (d) => d.toISOString().split("T")[0];

const getMaxBirthDate = () => {
  const d = new Date();
  d.setFullYear(d.getFullYear() - 16);
  return toISODate(d);
};

const getMinBirthDate = () => "1900-01-01";

const blockTyping = (e) => {
  if (e.key === "Tab") return;
  e.preventDefault();
};

const DateInputWithMask = ({ value, onChange, name, disabled, id, required, className, ...props }) => {
  const { t } = useTranslation();
  const dateRef = useRef(null);
  const [text, setText] = useState(() => isoToFR(value));
  const [error, setError] = useState("");
  
  const min = getMinBirthDate();
  const max = getMaxBirthDate();

  const handleCalendarChange = (e) => {
    const raw = e.target.value || "";
    
    if (raw && raw < min) {
      setError(t("Date invalide"));
      setText("");
      onChange?.({ target: { name, value: "" } });
      e.target.value = "";
      setTimeout(() => setError(""), 3000);
      return;
    }
    
    if (raw && raw > max) {
      setError(t("Date invalide"));
      setText("");
      onChange?.({ target: { name, value: "" } });
      e.target.value = "";
      setTimeout(() => setError(""), 3000);
      return;
    }
    
    setError("");
    setText(isoToFR(raw));
    onChange?.({ target: { name, value: raw } });
  };

  const openPicker = () => {
    if (disabled || !dateRef.current) return;
    setError("");
    if (typeof dateRef.current.showPicker === "function") {
      dateRef.current.showPicker();
    } else {
      dateRef.current.focus();
    }
  };

  const inputStyle = {
    width: "100%",
    opacity: 1,
    background: "transparent",
    position: "relative",
    zIndex: 2,
    color: "transparent",
    textShadow: "0 0 0 transparent",
    caretColor: "transparent"
  };

  const overlayStyle = {
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "center",
    padding: "0 12px",
    zIndex: 3,
    pointerEvents: "none",
    backgroundColor: disabled ? "#eee" : "transparent"
  };

  const errorStyle = {
    color: "#d32f2f",
    fontSize: "0.875rem",
    marginTop: "4px",
    display: error ? "block" : "none"
  };

  return (
    <div className={className}>
      <div onMouseDown={openPicker} style={{ position: "relative" }}>
        <input
          ref={dateRef}
          type="date"
          value={value || ""}
          onChange={handleCalendarChange}
          name={name}
          id={id}
          required={required}
          disabled={disabled}
          min={getMinBirthDate()}
          max={getMaxBirthDate()}
          onKeyDown={blockTyping}
          onPaste={(e) => e.preventDefault()}
          onDrop={(e) => e.preventDefault()}
          onWheel={(e) => e.currentTarget.blur()}
          style={inputStyle}
          aria-label={props["aria-label"]}
          aria-invalid={error ? "true" : props["aria-invalid"]}
          aria-describedby={error ? `${id}-error` : props["aria-describedby"]}
        />
        <div style={overlayStyle}>
          <span style={{ color: disabled ? "#777" : "inherit" }}>
            {text || t("Date de naissance")}
          </span>
        </div>
      </div>
      {error && (
        <div id={`${id}-error`} style={errorStyle} role="alert">
          {error}
        </div>
      )}
    </div>
  );
};

export default DateInputWithMask;